import React from 'react';
import SmiWidget from "../SmiWidget"

export const PopupModal = ({ show, onClose, isFull }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <span className="close-modal-button" onClick={onClose}>&times;</span>
          {isFull ? <SmiWidget blockId={'30236'}/> : <SmiWidget blockId={'30206'}/>}
      </div>
    </div>
  );
};
